class DataValidationError extends Error {
    constructor(fields) {
        super();
        this.fields = fields;
    }
}

export default DataValidationError;
